// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3DWek","unreadBadge":"styles_unreadBadge__1xZNP","modalContent":"styles_modalContent__2ezyP","modal":"styles_modal__rZgdr"};